import { IsString, IsEmail, IsArray } from 'class-validator';
import { UserInterface } from './user.interface';
import { AbstractModel } from '../models/abstract.model';

export class UserModel extends AbstractModel implements UserInterface {

    @IsString()
    public name: string = '';

    @IsEmail()
    public email: string = '';

    @IsString()
    public password: string = '';

    @IsArray()
    public _roleIds: number[] = [];
}
